"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var marketApi = _interopRequireWildcard(require("@/api/market"));
var marketActivityApi = _interopRequireWildcard(require("@/api/marketActivity"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _pagesHeader = _interopRequireDefault(require("@/components/base/pagesHeader"));
var _merchant = require("@/api/merchant");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketActivityAdd',
  components: {
    Tinymce: _Tinymce.default,
    PagesHeader: _pagesHeader.default
  },
  data: function data() {
    var _this2 = this;
    var baseSettingData = {
      address: false,
      activity_record: false,
      goods_img: false,
      device_info: false,
      stall_introduce: false,
      introduce: false,
      business_food_license: false,
      health_certificate: false,
      max_kw: false,
      id_card: true,
      id_card_photo: true,
      goods: true,
      // 商品名称默认勾选
      sales_type: true,
      // 售卖类型默认勾选
      name: false,
      phone: false,
      wechat: true,
      wechat_photo: true,
      need_count: true
    };
    return {
      isEdit: false,
      currentStep: '0',
      // 当前步骤（字符串类型，用于tabs）
      stepLoading: false,
      // 步骤保存加载状态
      submitLoading: false,
      marketLoading: false,
      marketOptions: [],
      allMarketOptions: [],
      // 缓存所有集市数据
      bulletScreenInput: '',
      selectedMerchantName: '',
      selectedMerchantPhone: '',
      merchantLoading: false,
      lastRequestedMerId: null,
      // 步骤标签配置
      stepTabs: [{
        name: '0',
        title: '基础信息'
      }, {
        name: '1',
        title: '内容设置'
      }, {
        name: '2',
        title: '费用设置'
      }],
      form: {
        id: null,
        // 活动ID，用于判断是新增还是编辑
        activityName: '',
        activityImg: [],
        activityInfo: '',
        agreementInfo: '',
        timeRemark: '',
        bulletScreen: [],
        agreementStatus: 0,
        commission: 0,
        commissionStatus: 0,
        deposit: 0,
        performanceBond: 0,
        promotionStatus: 0,
        promotionInfo: '',
        promotion: 0,
        depositRule: '',
        registrationTime: [],
        // 报名时间区间
        activityTime: [],
        // 活动时间区间
        needCount: 1,
        // 招募摊位数
        marketId: null,
        merId: null,
        processStatus: 0,
        setting: '',
        status: 1,
        // 默认下架状态
        marketActivityExtList: []
      },
      // 表单配置选项（从后端获取）
      settingOptions: {
        address: '常住地址',
        activity_record: '市集经验',
        goods_img: '商品图片和摆台图',
        device_info: '用电需求',
        stall_introduce: '摊位名或品牌名',
        introduce: '一句话介绍自己',
        business_food_license: '营业执照或食品经营许可证',
        health_certificate: '健康证',
        max_kw: '最大用电功率(根据用电需求开关配置)',
        id_card: '身份证号',
        id_card_photo: '身份证图片',
        goods: '商品名称',
        sales_type: '售卖商品类型',
        name: '姓名',
        phone: '手机号',
        wechat: '微信号',
        wechat_photo: '微信二维码照片',
        need_count: '申请摊位数'
      },
      // 表单配置数据
      defaultSettingData: _objectSpread({}, baseSettingData),
      settingData: _objectSpread({}, baseSettingData),
      rules: {
        // 步骤1：基本信息验证
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'blur'
        }],
        marketId: [{
          required: true,
          message: '请选择关联集市',
          trigger: 'change'
        }],
        registrationTime: [{
          required: true,
          message: '请选择报名时间',
          trigger: 'change'
        }],
        activityTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        needCount: [{
          required: true,
          message: '请输入招募摊位数',
          trigger: 'change'
        }],
        // 步骤2：内容设置验证
        activityImg: [{
          validator: function validator(rule, value, callback) {
            if (!_this2.form.activityImg || _this2.form.activityImg.length === 0) {
              callback(new Error('请上传活动图片'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        activityInfo: [{
          required: true,
          message: '请输入活动详情',
          trigger: 'blur'
        }],
        setting: [{
          validator: function validator(rule, value, callback) {
            var hasSelected = Object.values(_this2.settingData).some(function (val) {
              return val === true;
            });
            if (!hasSelected) {
              callback(new Error('请至少选择一个表单配置项'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      // 每个步骤的验证规则
      stepRules: {
        0: ['marketId', 'activityName', 'registrationTime', 'activityTime', 'needCount'],
        // 基本信息
        1: ['activityImg', 'activityInfo', 'setting'],
        // 内容设置
        2: [] // 费用设置（无必填项）
      },
      // 字段提示信息
      fieldTooltips: {
        marketId: '请选择要举办活动的集市，系统将自动关联该集市的商户信息',
        activityName: '请输入活动的名称，建议简洁明了，便于用户理解',
        registrationTime: '设置活动报名的时间范围，用户只能在此时间段内报名参加',
        activityTime: '设置活动实际举办的时间范围，应与报名时间合理衔接',
        timeRemark: '补充说明活动时间安排、签到要求或特殊时间提醒',
        needCount: '设置本次活动需要招募的摊位数量，用于控制报名人数',
        activityImg: '上传活动相关图片，最多可上传9张，建议上传3-5张高质量图片展示活动特色',
        activityInfo: '详细描述活动内容、规则、注意事项等，帮助用户了解活动详情',
        bulletScreen: '按条配置活动详情页展示的弹幕文案，保存时自动拼接为逗号分隔字符串',
        agreementStatus: '开启协议后，用户报名时需要同意相关协议条款',
        agreementInfo: '设置用户报名时需要同意的协议内容，如活动规则、免责声明等',
        setting: '选择用户报名时需要填写的表单字段，必选字段不可编辑',
        commissionStatus: '开启抽成后，平台将从活动收入中抽取一定比例的费用',
        commission: '设置抽成比例，建议根据活动类型和市场情况合理设置',
        deposit: '设置用户报名时需要缴纳的押金金额，用于保证参与质量',
        performanceBond: '设置商户参与活动时需要缴纳的履约保证金金额',
        promotionStatus: '开启后可配置推广协议，并在扩展费用设置中展示公共佣金配置',
        promotionInfo: '设置推广开启后展示给用户的推广协议内容',
        promotion: '推广开启后，扩展费用设置中的公共佣金金额配置',
        depositRule: '详细说明押金的使用规则、退还条件等，让用户清楚了解',
        marketActivityExtList: '设置额外的费用项目，如摊位费、设备费等，费用和抽成可单独添加也可以组合使用',
        status: '设置活动的当前状态，下架状态的活动用户无法看到和报名'
      }
    };
  },
  computed: {
    // 计算属性确保响应式更新
    computedSettingOptions: function computedSettingOptions() {
      return this.settingOptions;
    },
    computedSettingData: function computedSettingData() {
      return this.settingData;
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    // 确保DOM完全渲染后再初始化
    this.$nextTick(function () {
      _this3.initPage();
    });
  },
  watch: {
    'form.promotionStatus': function formPromotionStatus(value) {
      var _this4 = this;
      if (Number(value) !== 1) {
        this.form.promotionInfo = '';
        this.form.promotion = 0;
        this.form.marketActivityExtList.forEach(function (fee) {
          _this4.$set(fee, 'promotion', 0);
        });
      }
    }
  },
  methods: {
    /**
     * 加载活动数据（编辑模式）
     */
    loadActivityData: function loadActivityData(activityId) {
      var _this5 = this;
      if (!activityId) return Promise.reject('活动ID不能为空');
      return marketActivityApi.marketActivityInfo(activityId).then(function (res) {
        if (res) {
          var marketActivityExtList = _this5.parseMarketActivityExtList(res.marketActivityExtList || []);

          // 填充表单数据
          _this5.form = _objectSpread(_objectSpread(_objectSpread({}, _this5.form), res), {}, {
            // 处理图片数据
            activityImg: _this5.parseImageData(res.activityImg),
            // 处理时间数据
            registrationTime: res.startTime && res.endTime ? [res.startTime, res.endTime] : [],
            activityTime: res.marketStartTime && res.marketEndTime ? [res.marketStartTime, res.marketEndTime] : [],
            bulletScreen: _this5.parseBulletScreenData(res.bulletScreen),
            promotionStatus: res.promotionStatus !== undefined ? Number(res.promotionStatus) : 0,
            promotionInfo: res.promotionInfo || '',
            promotion: _this5.parseMoneyNumber(res.promotion),
            performanceBond: res.performanceBond !== undefined && res.performanceBond !== null ? res.performanceBond : 0,
            // 处理扩展费用数据
            marketActivityExtList: marketActivityExtList
          });

          // 设置编辑模式
          _this5.isEdit = true;
          console.log('活动数据已加载:', _this5.form);
          // 编辑回显：根据已有关联的集市回显商户信息
          if (_this5.form.marketId) {
            _this5.loadMerchantsByMarket(_this5.form.marketId);
          }
          return res;
        }
      }).catch(function (error) {
        console.error('加载活动数据失败:', error);
        _this5.$message.error('加载活动数据失败');
        throw error;
      });
    },
    /**
     * 解析图片数据
     */
    parseImageData: function parseImageData(imageData) {
      if (!imageData) return [];
      try {
        // 如果是JSON字符串，解析为数组
        if (typeof imageData === 'string') {
          var parsed = JSON.parse(imageData);
          return Array.isArray(parsed) ? parsed : [];
        }
        // 如果是数组，直接返回
        if (Array.isArray(imageData)) {
          return imageData;
        }
        // 如果是逗号分隔的字符串，分割为数组
        if (typeof imageData === 'string' && imageData.includes(',')) {
          return imageData.split(',').filter(function (img) {
            return img.trim();
          });
        }
        return [];
      } catch (error) {
        console.error('解析图片数据失败:', error);
        return [];
      }
    },
    /**
     * 解析详情弹幕配置
     */
    parseBulletScreenData: function parseBulletScreenData(bulletScreen) {
      if (!bulletScreen) return [];
      if (Array.isArray(bulletScreen)) {
        return bulletScreen.map(function (item) {
          return typeof item === 'string' ? item.trim() : item;
        }).filter(function (item) {
          return item !== undefined && item !== null && String(item).trim() !== '';
        });
      }
      if (typeof bulletScreen === 'string') {
        var trimmed = bulletScreen.trim();
        if (!trimmed) return [];
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.map(function (item) {
              return typeof item === 'string' ? item.trim() : item;
            }).filter(function (item) {
              return item !== undefined && item !== null && String(item).trim() !== '';
            });
          }
        } catch (error) {
          // ignore parse error
        }
        return trimmed.split(',').map(function (item) {
          return item.trim();
        }).filter(function (item) {
          return item;
        });
      }
      return [];
    },
    /**
     * 序列化详情弹幕配置
     */
    serializeBulletScreenData: function serializeBulletScreenData(bulletScreen) {
      return this.parseBulletScreenData(bulletScreen).join(',');
    },
    /**
     * 将后端金额字符串解析为前端可编辑数字
     */
    parseMoneyNumber: function parseMoneyNumber(value) {
      if (value === undefined || value === null || value === '') return 0;
      var parsedValue = Number(value);
      return Number.isNaN(parsedValue) ? 0 : parsedValue;
    },
    /**
     * 将金额统一格式化为后端需要的字符串
     */
    formatMoneyString: function formatMoneyString(value) {
      var parsedValue = this.parseMoneyNumber(value);
      return parsedValue.toFixed(2);
    },
    /**
     * 解析扩展费用数据
     */
    parseMarketActivityExtList: function parseMarketActivityExtList(extList) {
      var _this6 = this;
      if (!Array.isArray(extList)) return [];
      return extList.map(function (item) {
        // 仅配置单抽时，费用字段可能是默认的 0；不能因为费用名称存在就判定为免费
        var rawExtFee = Number(item.extFee);
        var hasExplicitFee = item.extFee !== undefined && item.extFee !== null && item.extFee !== '';
        var hasCommissionConfig = item.commissionStatusExt === 1 || item.commissionStatusExt === true || item.commissionExt !== undefined && item.commissionExt !== null && Number(item.commissionExt) > 0;
        var hasFee = hasExplicitFee && (rawExtFee !== 0 || !hasCommissionConfig);
        var feeMode = rawExtFee < 0 ? 'subsidy' : rawExtFee === 0 && hasFee ? 'free' : 'normal';
        // 判断是否有抽成数据：抽成状态字段存在（不管是0还是1），或者抽成比例字段存在
        var hasCommission = feeMode === 'normal' && !!(item.commissionStatusExt !== undefined || item.commissionExt !== undefined);
        // 判断是否设置区间费用：如果extFeeMax存在，则开启区间费用
        var isRangeFee = !!(item.extFeeMax !== undefined && item.extFeeMax !== null && item.extFeeMax !== '' && Number(item.extFeeMax) !== 0);
        // 判断是否面议
        var negotiable = item.negotiable !== undefined ? item.negotiable : 0;
        // 如果面议开启，也需要设置hasFee或hasCommission以便显示面议开关
        var hasNegotiable = negotiable === 1;
        return {
          id: item.id || null,
          activityId: item.activityId || _this6.form.id,
          extName: item.extName || '',
          extFee: item.extFee !== undefined && item.extFee !== null ? Math.abs(Number(item.extFee)) : 0,
          extFeeMax: item.extFeeMax !== undefined && item.extFeeMax !== null ? item.extFeeMax : 0,
          extType: item.extType !== undefined ? item.extType : 0,
          unit: item.unit || '天',
          unitValue: item.unitValue || 1,
          feeRemark: item.feeRemark || '',
          commissionStatusExt: feeMode === 'normal' && item.commissionStatusExt !== undefined ? item.commissionStatusExt === 1 || item.commissionStatusExt === true ? 1 : 0 : 0,
          commissionExt: feeMode === 'normal' && item.commissionExt !== undefined && item.commissionExt !== null ? item.commissionExt : 0,
          promotion: _this6.parseMoneyNumber(item.promotion),
          negotiable: negotiable,
          feeMode: feeMode,
          isRangeFee: isRangeFee,
          isDel: item.isDel || false,
          // 设置hasFee和hasCommission，用于控制费用和抽成设置区域的显示
          // 如果面议开启，不显示费用和抽成设置，但保留这些字段以便后续操作
          hasFee: hasNegotiable ? false : hasFee,
          hasCommission: hasNegotiable ? false : hasCommission
        };
      });
    },
    /**
     * 处理扩展费用数据提交
     */
    processMarketActivityExtList: function processMarketActivityExtList() {
      var _this7 = this;
      var extList = this.form.marketActivityExtList || [];
      return extList.map(function (fee) {
        var processedFee = {
          isDel: fee.isDel || false
        };

        // 面议字段
        processedFee.negotiable = fee.negotiable !== undefined ? fee.negotiable : 0;

        // 费用名称作为公共字段，只要有费用名称值或存在抽成数据或面议或费用备注，都应该保存
        processedFee.extName = fee.extName || '';

        // 费用备注作为公共字段，只要有值就保存
        processedFee.feeRemark = fee.feeRemark || '';

        // 费用类型作为公共字段，无论是否有费用、抽成或面议，都应该保存
        processedFee.extType = fee.extType !== undefined ? fee.extType : 0;
        if (_this7.form.promotionStatus === 1 && fee.feeMode === 'normal') {
          processedFee.promotion = _this7.formatMoneyString(fee.promotion);
        } else if (fee.id || fee.promotion !== undefined) {
          processedFee.promotion = '0.00';
        }

        // 如果存在费用数据，添加费用相关字段
        // 注意：hasFee 和 isRangeFee 是前端控制字段，不会提交到后端
        // 如果之前有费用数据（有id），即使现在移除了或设置为面议，也要提交费用字段（设置为默认值）
        // 如果设置了面议（negotiable === 1）且有id，也要提交费用字段以便重置数据
        if (fee.negotiable !== 1) {
          // 不是面议：如果是有id的记录（已保存的数据），无论hasFee是否为true，都要提交费用字段
          // 如果是新增记录，只有当hasFee为true时才提交
          if (fee.id || fee.hasFee) {
            var feeAmount = fee.extFee !== undefined && fee.extFee !== null ? Math.abs(Number(fee.extFee)) : 0;
            processedFee.extFee = fee.feeMode === 'subsidy' ? -feeAmount : fee.feeMode === 'free' ? 0 : feeAmount;
            processedFee.unit = fee.unit || '天';
            processedFee.unitValue = fee.unitValue !== undefined && fee.unitValue !== null ? fee.unitValue : 1;
            // 如果设置了区间费用，添加最高费用；负数同样是有效金额
            // 注意：直接判断 extFeeMax，不依赖 isRangeFee 字段
            if (fee.feeMode === 'normal' && (fee.isRangeFee || fee.extFeeMax !== undefined && fee.extFeeMax !== null && fee.extFeeMax !== '' && Number(fee.extFeeMax) !== 0)) {
              processedFee.extFeeMax = fee.extFeeMax;
            } else {
              // 如果没有区间费用或已移除，设置为0
              processedFee.extFeeMax = 0;
            }
          }
        } else {
          // 面议：如果有id（已保存的数据），也要提交费用字段（设置为默认值）以便重置
          if (fee.id) {
            processedFee.extFee = 0;
            processedFee.extFeeMax = 0;
            processedFee.unit = '天';
            processedFee.unitValue = 1;
          }
        }

        // 如果存在抽成数据，添加抽成相关字段
        // 注意：hasCommission 是前端控制字段，不会提交到后端
        // 如果之前有抽成数据（有id），即使现在移除了或设置为面议，也要提交抽成状态和比例为0
        // 如果设置了面议（negotiable === 1）且有id，也要提交抽成字段以便重置数据
        if (fee.negotiable !== 1) {
          // 不是面议：如果是有id的记录（已保存的数据），无论hasCommission是否为true，都要提交抽成字段
          // 如果是新增记录，只有当hasCommission为true时才提交
          if (fee.id || fee.hasCommission) {
            processedFee.commissionStatusExt = fee.commissionStatusExt !== undefined ? fee.commissionStatusExt === 1 || fee.commissionStatusExt === true ? 1 : 0 : 0;
            processedFee.commissionExt = fee.commissionExt !== undefined && fee.commissionExt !== null ? fee.commissionExt : 0;
          }
        } else {
          // 面议：如果有id（已保存的数据），也要提交抽成字段（设置为0）以便重置
          if (fee.id) {
            processedFee.commissionStatusExt = 0;
            processedFee.commissionExt = 0;
          }
        }

        // 如果存在id和activityId，则传入这些字段
        if (fee.id) {
          processedFee.id = fee.id;
        }
        if (fee.activityId) {
          processedFee.activityId = fee.activityId;
        }
        return processedFee;
      }).filter(function (fee) {
        return (
          // 过滤掉无效的数据，但保留已删除的数据（用于标记删除）
          // 至少需要有费用数据（extName存在）或抽成数据（commissionStatusExt存在）或面议或费用备注，或者标记为已删除
          // 注意：即使费用或抽成被移除，如果有id（已保存的数据），也应该保留以便更新为默认值
          fee.extName || fee.commissionStatusExt !== undefined || fee.negotiable === 1 || fee.feeRemark || fee.id || fee.isDel
        );
      });
    },
    /**
     * 初始化页面
     */
    initPage: function () {
      var _initPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var presetMarketId, parsedId, activityId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loadDefaultMarkets();

              // 如果从集市列表跳转带了marketId，则预选中该集市
              presetMarketId = this.$route && this.$route.query ? this.$route.query.marketId : null;
              if (presetMarketId) {
                // 转成数字（若可转），避免类型不一致导致的选择器不匹配
                parsedId = isNaN(Number(presetMarketId)) ? presetMarketId : Number(presetMarketId);
                this.form.marketId = parsedId;
              }

              // 检查路由参数，判断是否为编辑模式
              activityId = this.$route.params.id || this.$route.query.id;
              if (!activityId) {
                _context.n = 3;
                break;
              }
              _context.n = 1;
              return this.loadDefaultSetting();
            case 1:
              _context.n = 2;
              return this.loadActivityData(activityId);
            case 2:
              // 解析现有的配置数据，缺失项回落到默认配置
              if (this.form.setting) {
                this.parseSettingData(this.form.setting);
              } else {
                this.syncSettingDataWithDefault();
                this.updateSettingJson();
              }
              _context.n = 4;
              break;
            case 3:
              _context.n = 4;
              return this.loadDefaultSetting();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initPage() {
        return _initPage.apply(this, arguments);
      }
      return initPage;
    }(),
    /**
     * 处理标签点击
     */
    handleTabClick: function handleTabClick(tab) {
      var targetStep = parseInt(tab.name);
      var currentStepNum = parseInt(this.currentStep);

      // 如果点击的是当前步骤或之前的步骤，直接切换
      if (targetStep <= currentStepNum) {
        this.currentStep = tab.name;
        return;
      }

      // 如果点击的是后续步骤，需要先验证当前步骤
      this.validateCurrentStepBeforeSwitch(targetStep);
    },
    /**
     * 验证当前步骤后切换
     */
    validateCurrentStepBeforeSwitch: function validateCurrentStepBeforeSwitch(targetStep) {
      var _this8 = this;
      var currentStepNum = parseInt(this.currentStep);
      var fieldsToValidate = this.stepRules[currentStepNum];
      if (fieldsToValidate.length === 0) {
        // 如果没有必填字段，直接切换
        this.currentStep = targetStep.toString();
        return;
      }

      // 先进行额外验证：时间逻辑
      if (currentStepNum === 0) {
        if (this.form.registrationTime && this.form.registrationTime.length === 2) {
          if (new Date(this.form.registrationTime[0]) >= new Date(this.form.registrationTime[1])) {
            this.$message.error('报名结束时间必须大于开始时间');
            return;
          }
        }
        if (this.form.activityTime && this.form.activityTime.length === 2) {
          if (new Date(this.form.activityTime[0]) >= new Date(this.form.activityTime[1])) {
            this.$message.error('活动结束时间必须大于开始时间');
            return;
          }
        }
      }

      // 使用Promise方式验证字段
      var validationPromises = fieldsToValidate.map(function (field) {
        return new Promise(function (resolve) {
          _this8.$refs.activityForm.validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validationPromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (hasError) {
          _this8.$message.error('请完善当前步骤的必填信息后再切换');
          return;
        }

        // 验证通过，切换步骤
        _this8.currentStep = targetStep.toString();
      });
    },
    /**
     * 保存当前步骤
     */
    saveStep: function saveStep(stepIndex) {
      var _this9 = this;
      // 验证当前步骤的必填字段
      var fieldsToValidate = this.stepRules[stepIndex];
      if (fieldsToValidate.length === 0) {
        // 如果没有必填字段，直接进入下一步
        this.nextStep();
        return;
      }

      // 先进行额外验证：时间逻辑
      if (stepIndex === 0) {
        if (this.form.registrationTime && this.form.registrationTime.length === 2) {
          if (new Date(this.form.registrationTime[0]) >= new Date(this.form.registrationTime[1])) {
            this.$message.error('报名结束时间必须大于开始时间');
            return;
          }
        }
        if (this.form.activityTime && this.form.activityTime.length === 2) {
          if (new Date(this.form.activityTime[0]) >= new Date(this.form.activityTime[1])) {
            this.$message.error('活动结束时间必须大于开始时间');
            return;
          }
        }
      }

      // 使用Promise方式验证字段
      var validationPromises = fieldsToValidate.map(function (field) {
        return new Promise(function (resolve) {
          _this9.$refs.activityForm.validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validationPromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (hasError) {
          _this9.$message.error('请完善当前步骤的必填信息');
          return;
        }
        _this9.stepLoading = true;

        // 调用接口保存数据
        _this9.saveStepData(stepIndex);
      });
    },
    /**
     * 保存步骤数据
     */
    saveStepData: function saveStepData(stepIndex) {
      var _this0 = this;
      // 准备提交数据
      var submitData = _objectSpread(_objectSpread({}, this.form), {}, {
        // 将activityImg数组转换为字符串提交
        activityImg: this.form.activityImg.length > 0 ? JSON.stringify(this.form.activityImg) : '',
        bulletScreen: this.serializeBulletScreenData(this.form.bulletScreen),
        promotion: this.formatMoneyString(this.form.promotion),
        // 将时间区间转换为单独的开始和结束时间
        startTime: this.form.registrationTime && this.form.registrationTime.length === 2 ? this.form.registrationTime[0] : '',
        endTime: this.form.registrationTime && this.form.registrationTime.length === 2 ? this.form.registrationTime[1] : '',
        marketStartTime: this.form.activityTime && this.form.activityTime.length === 2 ? this.form.activityTime[0] : '',
        marketEndTime: this.form.activityTime && this.form.activityTime.length === 2 ? this.form.activityTime[1] : '',
        marketActivityExtList: this.processMarketActivityExtList()
      });

      // 根据是否有ID判断调用保存还是更新接口
      var apiCall = this.form.id ? marketActivityApi.marketActivityUpdate(submitData) : marketActivityApi.marketActivitySave(submitData);
      apiCall.then(function (res) {
        // 如果是新增操作，保存返回的ID
        if (!_this0.form.id && res) {
          _this0.form.id = res;
          console.log('活动ID已保存:', _this0.form.id);
          // 新增成功后调用loadActivityData获取活动数据
          _this0.loadActivityData(_this0.form.id);
        }
        _this0.$message.success('步骤保存成功');
        _this0.nextStep();
      }).catch(function (error) {
        _this0.$message.error(error.message || '保存失败');
      }).finally(function () {
        _this0.stepLoading = false;
      });
    },
    /**
     * 下一步
     */
    nextStep: function nextStep() {
      var currentStepNum = parseInt(this.currentStep);
      if (currentStepNum < 2) {
        this.currentStep = (currentStepNum + 1).toString();
      }
    },
    /**
     * 上一步
     */
    prevStep: function prevStep() {
      var currentStepNum = parseInt(this.currentStep);
      if (currentStepNum > 0) {
        this.currentStep = (currentStepNum - 1).toString();
      }
    },
    /**
     * 加载默认配置
     */
    loadDefaultSetting: function loadDefaultSetting() {
      var _this1 = this;
      return marketActivityApi.marketActivityGetSetting().then(function (res) {
        var serverSetting = res && _typeof(res) === 'object' ? res : {};
        Object.keys(_this1.settingOptions).forEach(function (key) {
          var defaultValue = Object.prototype.hasOwnProperty.call(_this1.defaultSettingData, key) ? !!_this1.defaultSettingData[key] : false;
          var value = Object.prototype.hasOwnProperty.call(serverSetting, key) ? !!serverSetting[key] : defaultValue;
          _this1.$set(_this1.defaultSettingData, key, value);
        });
        _this1.applyMandatorySettingFields(_this1.defaultSettingData);
        _this1.applyDeviceInfoDependency(_this1.defaultSettingData);
        _this1.syncSettingDataWithDefault();
        _this1.updateSettingJson();
        console.log('配置数据已加载:', _this1.settingData);
      }).catch(function (error) {
        console.warn('加载默认配置失败，使用默认值', error);
        _this1.syncSettingDataWithDefault();
        _this1.updateSettingJson();
      });
    },
    /**
     * 判断字段是否应该被禁用
     */
    isFieldDisabled: function isFieldDisabled(key) {
      // 必填固定字段不可编辑
      var disabledFields = ['name', 'phone', 'wechat', 'goods', 'sales_type', 'need_count', 'id_card', 'id_card_photo', 'wechat_photo', 'max_kw'];
      return disabledFields.includes(key);
    },
    /**
     * 获取配置项的中文标签
     */
    getSettingLabel: function getSettingLabel(key) {
      var labelMap = {
        address: '常住地址',
        activity_record: '市集经验',
        goods_img: '商品图片和摆台图',
        goods: '商品名称',
        device_info: '用电需求',
        stall_introduce: '摊位名或品牌名',
        introduce: '一句话介绍自己',
        id_card: '身份证号',
        id_card_photo: '身份证图片',
        sales_type: '售卖商品类型',
        name: '姓名',
        phone: '手机号',
        wechat: '微信号'
      };
      return labelMap[key] || '';
    },
    /**
     * 将当前配置同步为默认配置
     */
    syncSettingDataWithDefault: function syncSettingDataWithDefault() {
      var _this10 = this;
      Object.keys(this.settingOptions).forEach(function (key) {
        var value = Object.prototype.hasOwnProperty.call(_this10.defaultSettingData, key) ? !!_this10.defaultSettingData[key] : false;
        _this10.$set(_this10.settingData, key, value);
      });
      this.applyMandatorySettingFields(this.settingData);
      this.applyDeviceInfoDependency(this.settingData);
    },
    /**
     * 同步必填且不可编辑的配置项
     */
    applyMandatorySettingFields: function applyMandatorySettingFields(target) {
      var _this11 = this;
      ['goods', 'sales_type', 'id_card', 'id_card_photo'].forEach(function (key) {
        _this11.$set(target, key, true);
      });
    },
    /**
     * 根据用电需求开关同步最大用电功率开关
     */
    applyDeviceInfoDependency: function applyDeviceInfoDependency(target) {
      if (!target || !Object.prototype.hasOwnProperty.call(target, 'device_info')) {
        return;
      }
      var deviceInfoEnabled = !!target.device_info;
      this.$set(target, 'max_kw', deviceInfoEnabled);
    },
    /**
     * 解析表单配置数据（用于编辑模式）
     */
    parseSettingData: function parseSettingData(settingJson) {
      var _this12 = this;
      if (!settingJson) {
        console.log('settingJson为空，使用默认配置');
        this.syncSettingDataWithDefault();
        this.updateSettingJson();
        return;
      }
      try {
        var parsedData = JSON.parse(settingJson);
        if (_typeof(parsedData) === 'object') {
          var mergedSetting = {};
          Object.keys(this.settingOptions).forEach(function (key) {
            var defaultValue = Object.prototype.hasOwnProperty.call(_this12.defaultSettingData, key) ? !!_this12.defaultSettingData[key] : false;
            var hasSettingValue = Object.prototype.hasOwnProperty.call(parsedData, key);
            var value = hasSettingValue ? !!parsedData[key] : defaultValue;
            mergedSetting[key] = value;
          });
          this.applyMandatorySettingFields(mergedSetting);
          Object.keys(mergedSetting).forEach(function (key) {
            _this12.$set(_this12.settingData, key, mergedSetting[key]);
          });
          this.applyDeviceInfoDependency(this.settingData);
          console.log('配置数据已解析:', this.settingData);
          console.log('原始setting数据:', settingJson);

          // 更新表单的setting字段
          this.updateSettingJson();
        }
      } catch (error) {
        console.error('解析配置数据失败:', error);
        console.log('原始setting数据:', settingJson);
        this.syncSettingDataWithDefault();
        this.updateSettingJson();
      }
    },
    /**
     * 更新表单配置JSON
     */
    updateSettingJson: function updateSettingJson() {
      var _this13 = this;
      this.applyMandatorySettingFields(this.settingData);
      this.applyDeviceInfoDependency(this.settingData);
      this.form.setting = JSON.stringify(this.settingData);
      console.log('配置JSON已更新:', this.form.setting);
      console.log('当前配置数据:', this.settingData);

      // 触发表单验证
      this.$nextTick(function () {
        if (_this13.$refs.activityForm) {
          _this13.$refs.activityForm.validateField('setting');
        }
      });
    },
    /**
     * 搜索集市
     */
    searchMarkets: function searchMarkets(query) {
      if (query !== '') {
        // 如果没有缓存所有集市数据，先加载
        if (!this.allMarketOptions || this.allMarketOptions.length === 0) {
          this.loadAllMarkets();
        } else {
          // 客户端过滤
          this.marketOptions = this.allMarketOptions.filter(function (market) {
            return market.marketName.toLowerCase().includes(query.toLowerCase());
          });
        }
      } else {
        this.marketOptions = this.allMarketOptions || [];
      }
    },
    /**
     * 加载所有集市
     */
    loadAllMarkets: function loadAllMarkets() {
      var _this14 = this;
      this.marketLoading = true;
      // TODO  后续修改下这个接口 marketSelectList
      marketApi.marketList({
        page: 1,
        limit: 10000
      }).then(function (res) {
        _this14.allMarketOptions = (res === null || res === void 0 ? void 0 : res.list) || res || [];
        _this14.marketOptions = _this14.allMarketOptions;
        _this14.marketLoading = false;

        // 处理从路由传入的marketId与选项value类型不一致导致无法回显的问题
        var qId = _this14.$route && _this14.$route.query ? _this14.$route.query.marketId : null;
        if (qId != null) {
          var sampleId = _this14.marketOptions && _this14.marketOptions.length > 0 ? _this14.marketOptions[0].id : null;
          if (sampleId != null) {
            _this14.loadMerchantsByMarket(qId);
            // 根据选项id的类型进行一致化
            var normalized = typeof sampleId === 'number' ? Number(qId) : String(qId);
            _this14.form.marketId = normalized;
          } else {
            // 无法推断类型，退化为字符串
            _this14.form.marketId = String(qId);
          }
        }
      }).catch(function () {
        _this14.marketLoading = false;
      });
    },
    /**
     * 加载默认集市
     */
    loadDefaultMarkets: function loadDefaultMarkets() {
      if (this.allMarketOptions && this.allMarketOptions.length > 0) {
        this.marketOptions = this.allMarketOptions;
      } else {
        this.loadAllMarkets();
      }
    },
    /**
     * 集市选择变化
     */
    onMarketChange: function onMarketChange(value) {
      if (!value) {
        this.clearMerchantInfo();
        return;
      }
      // 根据集市ID在本地选项中反查，获取 merId 并回显商户
      this.loadMerchantsByMarket(value);
    },
    /**
     * 根据集市ID加载商户信息
     */
    loadMerchantsByMarket: function () {
      var _loadMerchantsByMarket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(marketId) {
        var list, merId, target, info, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              // 使用已加载的集市选项进行本地反查
              list = this.allMarketOptions && this.allMarketOptions.length > 0 ? this.allMarketOptions : this.marketOptions;
              merId = null;
              if (Array.isArray(list) && list.length > 0) {
                target = list.find(function (m) {
                  return m && String(m.id) === String(marketId);
                });
                merId = target && (target.merId || target.merID || target.merchantId);
              }

              // 回退：若本地列表未加载或未找到 merId，则请求集市详情获取 merId
              if (!(!merId && marketId)) {
                _context2.n = 4;
                break;
              }
              _context2.p = 1;
              _context2.n = 2;
              return marketApi.marketInfo(marketId);
            case 2:
              info = _context2.v;
              if (info) {
                merId = info.merId || info.merID || info.merchantId || null;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              merId = null;
            case 4:
              if (merId) {
                _context2.n = 5;
                break;
              }
              this.clearMerchantInfo();
              return _context2.a(2);
            case 5:
              this.form.merId = merId;
              // 拉取商户详情并回显
              this.loadMerchant(merId);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function loadMerchantsByMarket(_x) {
        return _loadMerchantsByMarket.apply(this, arguments);
      }
      return loadMerchantsByMarket;
    }(),
    /**
     * 根据 merId 拉取并回显商户详情（含竞态与异常处理）
     */
    loadMerchant: function () {
      var _loadMerchant = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(merId) {
        var res, data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (merId) {
                _context3.n = 1;
                break;
              }
              this.clearMerchantInfo();
              return _context3.a(2);
            case 1:
              this.merchantLoading = true;
              this.lastRequestedMerId = String(merId);
              _context3.p = 2;
              _context3.n = 3;
              return (0, _merchant.merchantDetailApi)(merId);
            case 3:
              res = _context3.v;
              if (!(this.lastRequestedMerId !== String(merId))) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              data = res && (res.data || res);
              this.selectedMerchantName = data && (data.name || data.realName || data.merchantName) || '';
              this.selectedMerchantPhone = data && (data.phone || data.mobile || data.tel) || '';
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              this.selectedMerchantName = '';
              this.selectedMerchantPhone = '';
            case 6:
              _context3.p = 6;
              // 仅在当前请求仍为最新时关闭loading，避免闪烁
              if (this.lastRequestedMerId === String(merId)) {
                this.merchantLoading = false;
              }
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 5, 6, 7]]);
      }));
      function loadMerchant(_x2) {
        return _loadMerchant.apply(this, arguments);
      }
      return loadMerchant;
    }(),
    /**
     * 清空商户信息
     */
    clearMerchantInfo: function clearMerchantInfo() {
      this.form.merId = null;
      this.selectedMerchantName = '';
      this.selectedMerchantPhone = '';
    },
    /**
     * 点击活动图片上传
     */
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;

      // 检查当前图片数量，限制最多9张
      if (this.form.activityImg.length >= 9) {
        this.$message.warning('最多只能上传9张图片');
        return;
      }
      this.$modalUpload(function (img) {
        if (!img) return;
        // 如果是多选，将新选择的图片添加到现有数组中
        if (multiple) {
          var newImages = img.map(function (item) {
            return item.sattDir;
          });
          var totalImages = _this.form.activityImg.length + newImages.length;
          if (totalImages > 9) {
            _this.$message.warning('最多只能上传9张图片，已自动截取前' + (9 - _this.form.activityImg.length) + '张');
            var remainingSlots = 9 - _this.form.activityImg.length;
            _this.form.activityImg = [].concat(_toConsumableArray(_this.form.activityImg), _toConsumableArray(newImages.slice(0, remainingSlots)));
          } else {
            _this.form.activityImg = [].concat(_toConsumableArray(_this.form.activityImg), _toConsumableArray(newImages));
          }
        } else {
          // 单选模式，替换第一张图片
          _this.form.activityImg = [img[0].sattDir];
        }
      }, multiple, 'activity');
    },
    /**
     * 删除图片
     */
    removeImage: function removeImage(index) {
      this.form.activityImg.splice(index, 1);
    },
    /**
     * 添加费用（创建新记录）
     */
    addFee: function addFee() {
      this.form.marketActivityExtList.push({
        id: null,
        // 新增费用没有ID
        activityId: this.form.id,
        // 关联的活动ID
        extName: '',
        extFee: 0,
        extFeeMax: 0,
        extType: 0,
        unit: '天',
        unitValue: 1,
        feeRemark: '',
        commissionStatusExt: 0,
        commissionExt: 0,
        promotion: 0,
        negotiable: 0,
        feeMode: 'normal',
        isRangeFee: false,
        isDel: false,
        // 新增费用默认未删除
        hasFee: false,
        // 默认未添加费用
        hasCommission: false // 默认未添加抽成
      });
    },
    /**
     * 为项目添加费用
     */
    addFeeToItem: function addFeeToItem(index) {
      var fee = this.form.marketActivityExtList[index];
      if (fee) {
        this.$set(fee, 'hasFee', true);
        // 如果费用金额为0或不存在，设置一个默认值，确保费用设置区域能显示
        if (!fee.extFee || fee.extFee === 0) {
          this.$set(fee, 'extFee', 1);
        }
        this.$set(fee, 'feeMode', fee.feeMode || 'normal');
        this.$set(fee, 'extName', fee.extName || '');
        this.$set(fee, 'extType', fee.extType !== undefined ? fee.extType : 0);
        this.$set(fee, 'unit', fee.unit || '天');
        this.$set(fee, 'unitValue', fee.unitValue || 1);
        this.$set(fee, 'feeRemark', fee.feeRemark || '');
        this.$set(fee, 'isRangeFee', fee.isRangeFee || false);
        this.$set(fee, 'extFeeMax', fee.extFeeMax || 0);
        // 如果面议开启，关闭面议
        if (fee.negotiable === 1) {
          this.$set(fee, 'negotiable', 0);
        }
      }
    },
    /**
     * 为项目添加抽成
     */
    addCommissionToItem: function addCommissionToItem(index) {
      var fee = this.form.marketActivityExtList[index];
      if (fee) {
        this.$set(fee, 'hasCommission', true);
        // 将抽成开关设置为开启状态，确保抽成设置区域能显示
        this.$set(fee, 'commissionStatusExt', 1);
        this.$set(fee, 'commissionExt', fee.commissionExt || 0);
        // 如果面议开启，关闭面议
        if (fee.negotiable === 1) {
          this.$set(fee, 'negotiable', 0);
        }
      }
    },
    /**
     * 从项目中移除费用
     */
    removeFeeFromItem: function removeFeeFromItem(index) {
      var fee = this.form.marketActivityExtList[index];
      if (fee) {
        this.$set(fee, 'hasFee', false);
        // 清空费用相关字段（保留费用名称和费用备注）
        this.$set(fee, 'extFee', 0);
        this.$set(fee, 'extFeeMax', 0);
        this.$set(fee, 'extType', 0);
        this.$set(fee, 'unit', '天');
        this.$set(fee, 'unitValue', 1);
        this.$set(fee, 'isRangeFee', false);
        // 如果没有抽成且不是面议，则删除整个记录
        if (!fee.hasCommission && fee.negotiable !== 1) {
          // 如果是新增的记录（没有ID），直接删除；否则标记为删除
          if (!fee.id) {
            this.form.marketActivityExtList.splice(index, 1);
          } else {
            this.removeFee(index);
          }
        }
      }
    },
    /**
     * 从项目中移除抽成
     */
    removeCommissionFromItem: function removeCommissionFromItem(index) {
      var fee = this.form.marketActivityExtList[index];
      if (fee) {
        // 清空抽成相关字段：抽成比例设置为0，抽成开关关闭
        this.$set(fee, 'commissionExt', 0);
        this.$set(fee, 'commissionStatusExt', 0);
        this.$set(fee, 'hasCommission', false);
        // 如果没有费用且不是面议，则删除整个记录
        if (!fee.hasFee && fee.negotiable !== 1) {
          // 如果是新增的记录（没有ID），直接删除；否则标记为删除
          if (!fee.id) {
            this.form.marketActivityExtList.splice(index, 1);
          } else {
            this.removeFee(index);
          }
        }
      }
    },
    /**
     * 删除费用
     */
    removeFee: function removeFee(index) {
      var fee = this.form.marketActivityExtList[index];

      // 如果费用有ID（已存在的数据），则设置isDel为true
      if (fee && fee.id) {
        this.$set(this.form.marketActivityExtList[index], 'isDel', true);
      } else {
        // 如果是新增的费用（没有ID），直接删除
        this.form.marketActivityExtList.splice(index, 1);
      }
    },
    /**
     * 恢复费用
     */
    restoreFee: function restoreFee(index) {
      this.$set(this.form.marketActivityExtList[index], 'isDel', false);
    },
    /**
     * 设置费用面议
     */
    setNegotiable: function setNegotiable(index) {
      var fee = this.form.marketActivityExtList[index];
      if (fee) {
        this.$set(fee, 'negotiable', 1);
        this.onNegotiableChange(index);
      }
    },
    /**
     * 关闭面议并恢复类型选择
     */
    cancelNegotiable: function cancelNegotiable(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee) return;
      this.$set(fee, 'negotiable', 0);
      this.$set(fee, 'feeMode', 'normal');
    },
    /**
     * 切换费用类型：免费上报0，补贴在提交时转为负值
     */
    onFeeModeChange: function onFeeModeChange(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee) return;
      if (fee.feeMode === 'free') {
        this.$set(fee, 'extFee', 0);
        this.$set(fee, 'extFeeMax', 0);
        this.$set(fee, 'isRangeFee', false);
      } else if (fee.feeMode === 'subsidy') {
        this.$set(fee, 'extFee', Math.max(1, Math.abs(Number(fee.extFee) || 0)));
        this.$set(fee, 'extFeeMax', 0);
        this.$set(fee, 'isRangeFee', false);
      } else {
        this.$set(fee, 'extFee', Math.max(1, Math.abs(Number(fee.extFee) || 0)));
      }
      if (fee.feeMode !== 'normal') {
        this.$set(fee, 'hasCommission', false);
        this.$set(fee, 'commissionStatusExt', 0);
        this.$set(fee, 'commissionExt', 0);
      }
    },
    /**
     * 面议开关变化处理
     */
    onNegotiableChange: function onNegotiableChange(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee) return;
      if (fee.negotiable === 1) {
        // 面议开启：清空费用和抽成数据，但保留费用名称
        this.$set(fee, 'hasFee', false);
        this.$set(fee, 'hasCommission', false);
        this.$set(fee, 'extFee', 0);
        this.$set(fee, 'extFeeMax', 0);
        this.$set(fee, 'extType', 0);
        this.$set(fee, 'unit', '天');
        this.$set(fee, 'unitValue', 1);
        this.$set(fee, 'commissionStatusExt', 0);
        this.$set(fee, 'commissionExt', 0);
        this.$set(fee, 'isRangeFee', false);
        this.$set(fee, 'feeMode', 'normal');
      } else {
        // 面议关闭：如果之前有费用或抽成数据，恢复显示
        // 这里不需要特别处理，因为hasFee和hasCommission会根据数据自动判断
      }
    },
    /**
     * 最低费用变化处理
     */
    onExtFeeChange: function onExtFeeChange(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee || !fee.isRangeFee) return;

      // 如果最高费用小于等于最低费用，自动调整为最低费用 + 1
      if (fee.extFeeMax !== undefined && fee.extFeeMax !== null && fee.extFeeMax <= fee.extFee) {
        this.$set(fee, 'extFeeMax', (fee.extFee || 0) + 1);
        this.$message.warning('最高费用必须大于最低费用，已自动调整为最低费用 + 1');
      }
    },
    /**
     * 最高费用变化处理
     */
    onExtFeeMaxChange: function onExtFeeMaxChange(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee || !fee.isRangeFee) return;

      // 验证最高费用必须大于最低费用
      if (fee.extFeeMax !== undefined && fee.extFeeMax !== null && fee.extFeeMax <= (fee.extFee || 0)) {
        this.$set(fee, 'extFeeMax', (fee.extFee || 0) + 1);
        this.$message.warning('最高费用必须大于最低费用');
      }
    },
    /**
     * 区间费用开关变化处理
     */
    onRangeFeeChange: function onRangeFeeChange(index) {
      var fee = this.form.marketActivityExtList[index];
      if (!fee) return;
      if (fee.isRangeFee) {
        // 开启区间费用时，如果最高费用未设置或小于等于最低费用，自动设置为最低费用 + 1
        if (!fee.extFeeMax || fee.extFeeMax <= (fee.extFee || 0)) {
          this.$set(fee, 'extFeeMax', (fee.extFee || 0) + 1);
        }
      } else {
        // 关闭区间费用时，清空最高费用
        this.$set(fee, 'extFeeMax', 0);
      }
    },
    /**
     * 判断扩展费用项是否已进入配置态
     */
    isFeeConfigActive: function isFeeConfigActive(fee) {
      if (!fee || fee.isDel) return false;
      return fee.negotiable === 1 || fee.hasFee || fee.hasCommission && fee.commissionStatusExt === 1;
    },
    /**
     * 判断是否显示公共佣金配置
     */
    shouldShowPromotionConfig: function shouldShowPromotionConfig(fee) {
      return this.form.promotionStatus === 1 && fee.feeMode === 'normal' && this.isFeeConfigActive(fee);
    },
    /**
     * 判断是否显示费用示例
     */
    shouldShowFeeExample: function shouldShowFeeExample(fee) {
      if (!this.isFeeConfigActive(fee)) return false;
      return fee.negotiable === 1 || fee.hasFee || fee.hasCommission && fee.commissionStatusExt === 1 && fee.commissionExt && fee.commissionExt > 0 || this.shouldShowPromotionConfig(fee) && this.parseMoneyNumber(fee.promotion) > 0;
    },
    /**
     * 生成费用示例文本
     */
    getFeeExample: function getFeeExample(fee) {
      // 如果面议，直接返回面议
      if (fee.negotiable === 1) {
        return '面议';
      }
      if (fee.feeMode === 'free') {
        return "".concat(fee.extName || '费用', "\uFF1A\u514D\u8D39\u6D3B\u52A8");
      }
      var parts = [];

      // 费用部分
      if (fee.hasFee && fee.extName && fee.extFee !== undefined && fee.extFee !== null && fee.extFee !== '' && fee.unitValue && fee.unit) {
        var typeText = fee.extType === 0 ? '摊位费用' : '补充费用';
        var feeText = '';
        if (fee.isRangeFee && fee.extFeeMax !== undefined && fee.extFeeMax !== null && fee.extFeeMax !== '' && Number(fee.extFeeMax) > Number(fee.extFee)) {
          feeText = "".concat(this.formatFeeAmount(fee.extFee, fee.feeMode), "-").concat(this.formatFeeAmount(fee.extFeeMax, fee.feeMode), "\u5143");
        } else {
          feeText = "".concat(this.formatFeeAmount(fee.extFee, fee.feeMode), "\u5143");
        }
        parts.push("".concat(typeText, "\uFF1A").concat(fee.extName).concat(feeText, "/").concat(fee.unitValue).concat(fee.unit));
        // 抽成部分
        if (fee.hasCommission && fee.commissionExt && fee.commissionExt > 0) {
          parts.push("\u62BD\u6210\uFF1A".concat(fee.commissionExt, "%"));
        }
        if (this.shouldShowPromotionConfig(fee) && this.parseMoneyNumber(fee.promotion) > 0) {
          parts.push("\u4F63\u91D1\uFF1A".concat(this.formatMoneyString(fee.promotion), "\u5143"));
        }
        if (fee.feeRemark) {
          parts.push("\u5907\u6CE8\uFF1A".concat(fee.feeRemark));
        }
      } else if (fee.hasCommission && fee.commissionStatusExt === 1 && fee.negotiable !== 1) {
        parts.push("".concat(fee.extName));
        // 抽成部分
        if (fee.hasCommission && fee.commissionExt && fee.commissionExt > 0) {
          parts.push("\u62BD\u6210\uFF1A".concat(fee.commissionExt, "%"));
        }
        if (this.shouldShowPromotionConfig(fee) && this.parseMoneyNumber(fee.promotion) > 0) {
          parts.push("\u4F63\u91D1\uFF1A".concat(this.formatMoneyString(fee.promotion), "\u5143"));
        }
      } else if (this.shouldShowPromotionConfig(fee) && this.parseMoneyNumber(fee.promotion) > 0) {
        parts.push("\u4F63\u91D1\uFF1A".concat(this.formatMoneyString(fee.promotion), "\u5143"));
      } else {
        parts.push('请完善费用信息');
      }
      if (parts.length === 0) {
        return '请完善信息';
      }
      return parts.join('  ');
    },
    /**
     * 格式化费用金额，负数按补贴金额展示
     */
    formatFeeAmount: function formatFeeAmount(value, feeMode) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return value;
      return feeMode === 'subsidy' ? "\u8865\u8D34".concat(Math.abs(amount)) : amount < 0 ? "\u8865\u8D34".concat(Math.abs(amount)) : "".concat(amount);
    },
    /**
     * 添加详情弹幕
     */
    addBulletScreenTag: function addBulletScreenTag() {
      var value = (this.bulletScreenInput || '').trim();
      if (!value) return;
      var bulletScreenList = this.parseBulletScreenData(this.form.bulletScreen);
      if (bulletScreenList.includes(value)) {
        this.$message.warning('该弹幕内容已存在');
        return;
      }
      bulletScreenList.push(value);
      this.$set(this.form, 'bulletScreen', bulletScreenList);
      this.bulletScreenInput = '';
    },
    /**
     * 删除详情弹幕
     */
    removeBulletScreenTag: function removeBulletScreenTag(index) {
      var bulletScreenList = this.parseBulletScreenData(this.form.bulletScreen);
      bulletScreenList.splice(index, 1);
      this.$set(this.form, 'bulletScreen', bulletScreenList);
    },
    /**
     * 提交表单
     */
    submitForm: function submitForm() {
      var _this15 = this;
      // 防止重复提交
      if (this.submitLoading) {
        return;
      }

      // 验证所有步骤的必填字段
      var allRequiredFields = [].concat(_toConsumableArray(this.stepRules[0]), _toConsumableArray(this.stepRules[1]), _toConsumableArray(this.stepRules[2]));

      // 先进行额外验证：时间逻辑
      if (this.form.registrationTime && this.form.registrationTime.length === 2) {
        if (new Date(this.form.registrationTime[0]) >= new Date(this.form.registrationTime[1])) {
          this.$message.error('报名结束时间必须大于开始时间');
          return;
        }
      }
      if (this.form.activityTime && this.form.activityTime.length === 2) {
        if (new Date(this.form.activityTime[0]) >= new Date(this.form.activityTime[1])) {
          this.$message.error('活动结束时间必须大于开始时间');
          return;
        }
      }

      // 使用Promise方式验证字段
      var validationPromises = allRequiredFields.map(function (field) {
        return new Promise(function (resolve) {
          _this15.$refs.activityForm.validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validationPromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (hasError) {
          _this15.$message.error('请完善所有必填信息');
          return;
        }
        _this15.submitLoading = true;
        var submitData = _objectSpread(_objectSpread({}, _this15.form), {}, {
          // 将activityImg数组转换为字符串提交
          activityImg: _this15.form.activityImg.length > 0 ? JSON.stringify(_this15.form.activityImg) : '',
          bulletScreen: _this15.serializeBulletScreenData(_this15.form.bulletScreen),
          promotion: _this15.formatMoneyString(_this15.form.promotion),
          // 将时间区间转换为单独的开始和结束时间
          startTime: _this15.form.registrationTime && _this15.form.registrationTime.length === 2 ? _this15.form.registrationTime[0] : '',
          endTime: _this15.form.registrationTime && _this15.form.registrationTime.length === 2 ? _this15.form.registrationTime[1] : '',
          marketStartTime: _this15.form.activityTime && _this15.form.activityTime.length === 2 ? _this15.form.activityTime[0] : '',
          marketEndTime: _this15.form.activityTime && _this15.form.activityTime.length === 2 ? _this15.form.activityTime[1] : '',
          marketActivityExtList: _this15.processMarketActivityExtList()
        });

        // 根据是否有ID判断调用保存还是更新接口
        var apiCall = _this15.form.id ? marketActivityApi.marketActivityUpdate(submitData) : marketActivityApi.marketActivitySave(submitData);
        apiCall.then(function (res) {
          console.log(res, 'res');
          // 如果是新增操作，保存返回的ID
          if (!_this15.form.id && res) {
            _this15.form.id = res;
            console.log('活动ID已保存:', _this15.form.id);
          }
          var successMessage = _this15.form.id ? '活动更新成功' : '活动创建成功';
          _this15.$message.success(successMessage);
          _this15.goBack();
        }).catch(function (error) {
          _this15.$message.error(error.message || '操作失败');
        }).finally(function () {
          _this15.submitLoading = false;
        });
      });
    },
    /**
     * 返回列表
     */
    goBack: function goBack() {
      this.$router.push('/market/activity/list');
    }
  }
};